import React, { useContext, useState } from "react";
import Person from "./Person";
import { Link } from "react-router-dom";
import { SlOptions } from "react-icons/sl";
import { BiSolidMessageRounded } from "react-icons/bi";
import { FaUser } from "react-icons/fa";
import { AuthContext } from "../contexts/AuthContext";
import { WorkspaceContext } from "../contexts/WorkspaceContext";
import { joinRoomInbox } from "../services/conversations";
import { DisplayDiscussionForMiniScreenContext } from "../contexts/DisplayDiscussionForMiniScreenContext";
import { socket } from "../services/socket";

export default function DisplayContact({ idx, userT }) {
  const [visibleIndex, setVisibleIndex] = useState(null);
  const { user } = useContext(AuthContext);
  const { currentWorkspace } = useContext(WorkspaceContext);
  const workspaceId = currentWorkspace?._id;
  const [displayOpt, setDisplayOpt] = useState(false);
  const {
    setDisplayDiscussionForMiniScreen,
    setDestinataire,
    conversations,
    setConversations,
    setActiveRoomIdInbox,
  } = useContext(DisplayDiscussionForMiniScreenContext);
  const toggleOptionsList = (idxParams) => {
    if (visibleIndex === idxParams) {
      setVisibleIndex(null);
    } else {
      setVisibleIndex(idxParams);
    }
  };
  return (
    <>
      <li>
        <div className="tyn-media-group tyn-aside-item">
          <div className="tyn-media">
            <Person
              person={{
                image: userT.userImage,
                nom: userT.nom,
                prenom: userT.prenom,
                colors: userT.color,
                userId: userT.color,
              }}
            />
          </div>

          <div className="tyn-media-col">
            <div className="tyn-media-row">
              <h6 className="name">{userT.prenom + " " + userT.nom}</h6>
            </div>
            <div className="tyn-media-row">
              <p className="content">{userT.username}</p>
            </div>
          </div>
          <button
            className="btn btn-icon btn-white btn-pill dropdown-toggle"
            data-bs-toggle="dropdown"
            data-bs-offset="0,0"
            data-bs-auto-close="outside"
            onClick={() => {
              toggleOptionsList(idx);
              setDisplayOpt(!displayOpt);
            }}
          >
            <SlOptions />
          </button>
          {true && (
            <ul className="tyn-media-option-list me-n1">
              <li className="dropdown">
                <div
                  className={`dropdown-menu dropdown-menu-end ${
                    displayOpt ? "show" : ""
                  }`}
                  style={{
                    position: "absolute",
                    inset: "0px 0px auto auto",
                    margin: "0px",
                    transform: "translate3d(0px, 40px, 0px)",
                    right: "10px",
                    top: "-15px",
                  }}
                >
                  <ul className="tyn-list-links">
                    <li>
                      <button
                        data-bs-dismiss="modal"
                        onClick={() => {
                          setDisplayOpt(!displayOpt);
                          setConversations(!conversations);
                          joinRoomInbox(user, userT, workspaceId);
                          setDisplayDiscussionForMiniScreen(true);
                          setActiveRoomIdInbox(
                            user.userId > userT.userId
                              ? `${user.userId}_${userT.userId}`
                              : `${userT.userId}_${user.userId}`
                          );
                          setDestinataire(userT);
                          socket.emit(
                            "je_declare_tous_les_messages_inbox_de_cette_discussion_ouvert",
                            {
                              destinataire: user.userId,
                              roomId:
                                user.userId > userT.userId
                                  ? `${user.userId}_${userT.userId}`
                                  : `${userT.userId}_${user.userId}`,
                              workspaceId,
                            }
                          );
                          socket.emit(
                            "vaChercherLaConversation",
                            user.userId > userT.userId
                              ? `${user.userId}_${userT.userId}`
                              : `${userT.userId}_${user.userId}`,
                            workspaceId
                          );
                        }}
                      >
                        <BiSolidMessageRounded />
                        <span>Commencer à écrire</span>
                      </button>
                    </li>

                    <li>
                      <Link
                        data-bs-toggle="modal"
                        className="link"
                        to={`/contact/` + userT.username}
                      >
                        <FaUser />
                        <span>Voir le profil</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          )}
        </div>
      </li>
    </>
  );
}
